import { VuexModule, Module, Mutation } from 'vuex-module-decorators'
import { CurrentEnvironment, ICurrentEnvironment } from '@/config'

export interface IAppState {
  environment: ICurrentEnvironment
  devLinks: Array<string>
  reportId: number
  detailId: number
  dataUrl: string
  groups: Array<string>
}

@Module({ name: 'app' })
export default class extends VuexModule implements IAppState {
  public environment: ICurrentEnvironment = new CurrentEnvironment() as ICurrentEnvironment
  public devLinks: Array<string> = []
  public reportId: number = -1
  public detailId: number = -1
  public dataUrl: string = ''
  public groups: Array<string> = []

  @Mutation
  SET_CODE_LINKS(links: Array<string>) {
    this.devLinks = links
  }

  @Mutation
  SET_REPORT_ID(reportId: number) {
    this.reportId = reportId
  }

  @Mutation
  SET_DETAIL_ID(detailId: number) {
    this.detailId = detailId
  }

  @Mutation
  SET_REPORT_DATA_URL(dataUrl: string) {
    this.dataUrl = dataUrl
  }

  @Mutation
  SET_GROUPS(groups: Array<string>) {
    this.groups = groups
  }

  get userGroups() {
    return this.groups
  }
}
